/**
 * 聊天列表
 * Bai.Zhiming
 * 2019-7-10
 */
angular.module("chartListModule", [
    'c2cChartListModule',
    'groupChartListModule'
]).
directive("chartList", ['$q', 'imService', '$timeout', function($q, imService, $timeout) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            fn: '=',
            loginInfo: "="
        },
        templateUrl: "./IM/chatWindow/chartList/chartList_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [showContent description] 显示聊天内容简介
             * @param  {[type]} item [description] 账号条目
             * @return {[type]}      [description]
             */
            scope.showContent = function(item) {
                if (item.LastMsg.MsgBody[0].MsgType == "TIMCustomElem") {
                    let data = item.LastMsg.MsgBody[0].MsgContent.Data;
                    let $dom = $(`<div>${data}</div>`);
                    let hasEmotion = $dom.find("img").length > 0;
                    return (hasEmotion ? '[图文/表情]' : '') + item.LastMsg.MsgBody[0].MsgContent.Desc;
                }
                return item.MsgShow == '[图片]' ? item.MsgShow : item.LastMsg.MsgBody[0].MsgContent.Text
            }
            /**
             * [showContentGroup description] 显示聊天内容简介-群组
             * @param  {[type]} item [description] 账号条目
             * @return {[type]}      [description]
             */
            scope.showContentGroup = function(item) {
                if (item.LastMsg.MsgBody[0].MsgType == "TIMCustomElem") {
                    let data = item.LastMsg.MsgBody[0].MsgContent.Data;
                    let $dom = $(`<div>${data}</div>`);
                    let hasEmotion = $dom.find("img").length > 0;
                    return (item.fromAccountNick ? (item.fromAccountNick + ':') : '') + (hasEmotion ? '[图文/表情]' : '') + item.LastMsg.MsgBody[0].MsgContent.Desc;
                }
                return (item.fromAccountNick ? (item.fromAccountNick + ':') : '') + (item.MsgShow == '[图片]' ? item.MsgShow : item.LastMsg.MsgBody[0].MsgContent.Text);
            }
            /**
             * [watchChatWindowClose description] 监听关闭聊天窗口事件，清除所有自动已读
             * @return {[type]} [description]
             */
            function watchChatWindowClose() {
                scope.$watch("$root.chatWindowSwitch", (newV, oldV) => {
                    if (newV !== false) return;
                    setAutoRead(scope.status.selectedItem, false, false);
                    scope.status.selectedItem = "";
                    scope.fn.getSessionInfo(scope.status.selectedItem);
                });
            }
            /**
             * [watchChatTipBar description] 监控聊天提示栏发出的指令
             * @return {[type]} [description]
             */
            function watchChatTipBar() {
                scope.$on("goToTheChart", (event, data) => {
                    if (!data) return;
                    if (data.Type == 1) scope.clickC2CItem(data);
                    else scope.clickGroupItem(data);
                })
            }
            /**
             * [syncChatList description] 同步聊天列表
             * @return {[type]} [description]
             */
            function syncChatList() {
                scope.$watch('data.recnetContactList', (newV, oldV) => {
                    if (!newV) return;
                    let array = newV.filter(item => {
                        return item.UnreadMsgCount > 0;
                    });
                    scope.$root.imChatList = array;
                }, true);
            }
            /**
             * [clickC2CItem description]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            scope.clickC2CItem = function(item) {
                item.UnreadMsgCount = 0;
                if (scope.status.selectedItem && scope.status.selectedItem.Type == 1 && item.To_Account == scope.status.selectedItem.To_Account) return;
                if (scope.status.selectedItem) setAutoRead(scope.status.selectedItem, false, false);
                scope.status.selectedItem = item;
                scope.fn.getSessionInfo(item);
                saveSelectedItemToLocal(item);
            };
            /**
             * [clickGroupItem description]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            scope.clickGroupItem = function(item) {
                item.UnreadMsgCount = 0;
                if (scope.status.selectedItem && scope.status.selectedItem.Type == 2 && item.ToAccount == scope.status.selectedItem.ToAccount) return;
                if (scope.status.selectedItem) setAutoRead(scope.status.selectedItem, false, false);
                scope.status.selectedItem = item;
                scope.fn.getSessionInfo(item);
                saveSelectedItemToLocal(item);
            };
            /**
             * [saveSelectedItemToLocal description] 保存选中会话到本地
             * @param  {[type]} item [description]
             * @return {[type]} [description]
             */
            function saveSelectedItemToLocal(item) {
                let position = localStorage.getItem("imPosition");
                position = !position ? {} : JSON.parse(position);
                position.selectedSess = {
                    type: item.Type,
                    id: item.Type == 1 ? item.To_Account : item.ToAccount
                }
                localStorage.setItem('imPosition', JSON.stringify(position));
            }
            /**
             * [setAutoRead description] 上报已读
             * @param {[type]} sessionInfo [description] 会话信息
             * @param {[boolean]} isOn    [description] 是否以后都自动已读
             * @param {[boolean]} isResetAll    [description] 是否重置之前的未读消息
             */
            function setAutoRead(sessionInfo, isOn = true, isResetAll = true) {
                let type = sessionInfo.Type == 1 ? 'C2C' : 'GROUP';
                let account = sessionInfo.Type == 1 ? sessionInfo.To_Account : sessionInfo.ToAccount;
                let selSess = webim.MsgStore.sessByTypeId(type, account);
                webim.setAutoRead(selSess, isOn, isResetAll);
            }
            /**
             * [deleteC2CChat description] 删除会话
             * @param  {[type]} item [description] 对话信息
             * @param  {[Number]} index [description] 会话下标
             * @return {[type]}      [description]
             */
            scope.deleteC2CChat = function(item, index) {
                setAutoRead(item, true, false);
                webim.deleteChat({
                    To_Account: item.To_Account,
                    chatType: 1
                }, resp => {
                    $timeout(() => {
                        if (angular.isObject(scope.status.selectedItem) && item.To_Account == scope.status.selectedItem.To_Account) {
                            scope.status.selectedItem = "";
                        }
                        scope.data.recnetContactList.splice(index, 1);
                        scope.fn.delSession(item);
                        autoSelectFirst();
                    });
                });
            };
            /**
             * [删除群组会话 description] 删除群组会话
             * @param  {[type]} item [description] 对话信息
             * @param  {[Number]} index [description] 会话下标
             * @return {[type]}      [description]
             */
            scope.deleteGreoupChat = function(item, index) {
                let selSess = webim.MsgStore.sessByTypeId('GROUP', item.ToAccount);
                if (selSess) {
                    webim.groupMsgReaded({
                        "GroupId": item.ToAccount,
                        "MsgReadedSeq": selSess._impl.curMaxMsgSeq
                    });
                }
                webim.deleteChat({
                    To_Account: item.ToAccount,
                    chatType: 2
                }, resp => {
                    $timeout(() => {
                        if (angular.isObject(scope.status.selectedItem) && item.ToAccount == scope.status.selectedItem.ToAccount) {
                            scope.status.selectedItem = "";
                        }
                        scope.data.recnetContactList.splice(index, 1);
                        scope.fn.delSession(item);
                        autoSelectFirst();
                    });
                });
            };
            /**
             * [dateFormat description] 日期格式化
             * @param  {[type]} time [description]
             * @return {[type]}      [description]
             */
            scope.dateFormat = function(time) {
                return imService.dateFormat(time);
            }
            /**
             * [initStatus description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    reqRecentSessCount: 50, //初始化加载50条最近聊天记录
                    syncTimer: "", //同步消息延时器,
                    loginUser: `${scope.loginInfo.TENANTID}_${scope.loginInfo.USERNAME}`
                };
                scope.data = {
                    recentContactList: []
                };
                if (angular.isObject(scope.fn)) {
                    scope.fn.addSession = function(user, callback) {
                        for (let i = 0; i < scope.data.recnetContactList.length; i++) {
                            let item = scope.data.recnetContactList[i];
                            if (item.To_Account == user.To_Account) {
                                scope.data.recnetContactList.unshift(scope.data.recnetContactList.splice(i, 1)[0]); //如果已有聊天会话，顶到最上面来
                                autoSelectFirst();
                                if (angular.isFunction(callback)) callback();
                                return;
                            }
                        }
                        let newContcat = {
                            C2cImage: (angular.isArray(user.ProfileItem) && angular.isObject(user.ProfileItem[3])) ? user.ProfileItem[3].Value : '',
                            C2cNick: (angular.isArray(user.ProfileItem) && angular.isObject(user.ProfileItem[0])) ? user.ProfileItem[0].Value : '',
                            LastC2cMsgFrom_Account: user.To_Account,
                            LastMsg: {},
                            To_Account: user.To_Account,
                            Type: 1,
                            UnreadMsgCount: 0
                        };
                        getC2CHistoryMsgs(1, 0, user.To_Account).then(resp => {
                            let lastMsg = resp.MsgList.length > 0 ? resp.MsgList[0] : {
                                elems: [{
                                    content: {
                                        text: ""
                                    }
                                }]
                            }
                            let time = resp.MsgList.length > 0 ? resp.MsgList[0].time : Math.round(Number(new Date()) / 1e3);
                            newContcat.LastMsg.MsgBody = [{
                                MsgType: "TIMTextElem",
                                MsgContent: {
                                    Text: lastMsg.elems[0].content.text
                                }
                            }];
                            newContcat.MsgTimeStamp = time;
                            scope.data.recnetContactList.unshift(newContcat);
                            autoSelectFirst();
                            if (angular.isFunction(callback)) callback();
                        })
                    }
                    scope.fn.addSessionGroup = function(group, callback) {
                        for (let i in scope.data.recnetContactList) {
                            let theGroup = scope.data.recnetContactList[i];
                            if (theGroup.ToAccount == group.GroupId) {
                                scope.data.recnetContactList.unshift(scope.data.recnetContactList.splice(i, 1)[0]);
                                autoSelectFirst();
                                if (angular.isFunction(callback)) callback();
                                return;
                            }
                        }
                        let newContcat = {
                            groupImage: group.FaceUrl,
                            GroupNick: group.Name,
                            LastMsg: {
                                MsgBody: [{
                                    MsgType: "TIMTextElem",
                                    MsgContent: {
                                        Text: ''
                                    }
                                }]
                            },
                            ToAccount: group.GroupId,
                            MsgTimeStamp: Math.round(Number(new Date()) / 1e3),
                            Type: 2,
                            UnreadMsgCount: 0
                        }
                        scope.data.recnetContactList.unshift(newContcat);
                        autoSelectFirst();
                        if (angular.isFunction(callback)) callback();
                    }
                }
            }
            /**
             * [getC2CHistoryMsgs description] 获取好友聊天记录
             * @return {[type]} [description]
             */
            function getC2CHistoryMsgs(MaxCnt = 1, lastMsgTime = 0, to_Account) {
                let deffer = $q.defer();
                webim.getC2CHistoryMsgs({
                    LastMsgTime: lastMsgTime,
                    MaxCnt: MaxCnt,
                    MsgKey: "",
                    Peer_Account: to_Account
                }, resp => {
                    deffer.resolve(resp);
                }, error => {
                    console.log(error);
                    deffer.reject();
                });
                return deffer.promise;
            }
            /**
             * [initData description]
             * @return {[type]} [description]
             */
            function initData() {
                scope.loaders = initRecentContactList().then(resp => {
                    scope.data.recnetContactList = resp;
                    initLocalSelectedItem();
                    watchChatWindowSwitch();
                    receivingNewMsgBroadcasting();
                    return getAllUnreadMsg();
                }).then(() => {
                    syncChatList();
                    watchChatTipBar();
                    watchChatWindowClose();
                    //autoSelectFirst();
                });
            }
            /**
             * [initLocalSelectedItem description] 初始化本地存储的上次选中的会话
             * @return {[type]} [description]
             */
            function initLocalSelectedItem() {
                if (scope.$root.chatWindowSwitch) {
                    let position = localStorage.getItem("imPosition");
                    position = !position ? {} : JSON.parse(position);
                    let selectedItem = scope.data.recnetContactList.forEach(item => {
                        let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                        if (id != position.selectedSess.id) return;
                        if (item.Type == 1) {
                            scope.clickC2CItem(item);
                        } else {
                            scope.clickGroupItem(item);
                        }
                    });
                }
            }
            /**
             * [watchChatWindowSwitch description] 监听窗体显示开关
             * @return {[type]} [description]
             */
            function watchChatWindowSwitch() {
                scope.$watch("$root.chatWindowSwitch", (newV, oldV) => {
                    if (angular.isArray(scope.$root.imChatList) && scope.$root.imChatList.length > 0) return;
                    if (newV && !oldV) {
                        initLocalSelectedItem();
                    }
                });
            }
            /**
             * [getUnreadMsg description] 获取指定未读消息
             * @return {[type]} [description]
             */
            function getUnreadMsg(newMsg) {
                for (let i in scope.data.recnetContactList) {
                    let item = scope.data.recnetContactList[i];
                    let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                    for (let j in newMsg) {
                        let item_ = newMsg[j];
                        let sess = item_.sess;
                        if (id == sess.id()) {
                            let unread = sess.unread();
                            item.UnreadMsgCount = unread;
                            if (unread > 0) imService.playChatTips();
                        }
                    }
                }
                let selectedItem = scope.status.selectedItem;
                let selectedItemType = scope.status.selectedItem.Type == 1 ? 'C2C' : 'GROUP';
                let selectedId = angular.isObject(selectedItem) ? (selectedItem.Type == 1 ? selectedItem.To_Account : selectedItem.ToAccount) : '';
                for (let i in newMsg) {
                    let item_ = newMsg[i];
                    let sess = item_.sess;
                    if (selectedId == sess.id() && sess.type() == selectedItemType) {
                        setAutoRead(selectedItem);
                    }
                }
            }
            /**
             * [getAllUnreadMsg description] 获取所有未读消息
             * @return {[type]} [description]
             */
            function getAllUnreadMsg() {
                let deffer = $q.defer();
                webim.syncMsgs(() => {
                    let sessMap = webim.MsgStore.sessMap();
                    outerLoop: for (let i in sessMap) {
                        let item_ = sessMap[i];
                        let id_ = item_._impl.type == "C2C" ? item_._impl.name : item_._impl.id; //区分C2C和Group
                        innerLoop: for (let j = 0; j < scope.data.recnetContactList.length; j++) {
                            let item = scope.data.recnetContactList[j];
                            let id = item.Type == 1 ? item.To_Account : item.ToAccount; //区分C2C和Group
                            if (id === id_) {
                                ((item, item_) => {
                                    $timeout(() => {
                                        item.UnreadMsgCount = item_.unread();
                                        if (item.LastC2cMsgFrom_Account != (scope.loginInfo.TENANTID + "_" + scope.loginInfo.USERNAME) && item.UnreadMsgCount > 0) {
                                            imService.playChatTips();
                                        }
                                    });
                                })(item, item_)

                                break innerLoop;
                            }
                        }
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [autoSelectFirst description] 自动选择第一个聊天消息
             * @return {[type]} [description]
             */
            function autoSelectFirst() {
                if (scope.data.recnetContactList.length == 0) return;
                let item = scope.data.recnetContactList[0];
                if (item.Type == 1) {
                    scope.clickC2CItem(item);
                } else {
                    scope.clickGroupItem(item);
                }
            }
            /**
             * [receivingNewMsgBroadcasting description] 接收新消息广播
             * @return {[type]} [description]
             */
            function receivingNewMsgBroadcasting() {
                scope.$on("newMessage", (event, data) => {
                    syncMsgList(data).then(() => {
                        getUnreadMsg(data);
                    });
                });
                scope.$on("newMessageToLeft", (event, data) => {
                    syncMsgList(data);
                })
            }
            /**
             * [syncMsgList description] 同步消息
             * @param  {[type]} data [description] 新消息
             * @return {[type]}      [description]
             */
            function syncMsgList(data) {
                let deffer = $q.defer();
                let times = 0;
                if (scope.status.syncTimer) {
                    clearTimeout(scope.status.syncTimer);
                    scope.status.syncTimer = null;
                }
                scope.status.syncTimer = setTimeout(() => {
                    composeNewMsg(data, times, () => {
                        deffer.resolve();
                    });
                }, 500);
                return deffer.promise;
            }
            /**
             * [composeNewMsg description] 对比且组合新消息，为了提高体验，防止新消息进入后闪动
             * @param  {[object]} newMsg [description] 新消息
             * @return {[type]}      [description]
             */
            function composeNewMsg(newMsg, times, callback) {
                callback = angular.isFunction(callback) ? callback : function() {};
                if (times >= 3) {
                    callback();
                    return;
                }
                scope.loaders = initRecentContactList().then(resp => {
                    let newMsgList = resp;
                    //解决列表数据更新不及时的im  bug --start
                    let flag1 = newMsg.some(item => { //只要发现，有一个新消息列表的数据，再新会话列表中不存在,则认为不及时，需要重新请求
                        let id = item.sess._impl.id;
                        return newMsgList.every(_item => {
                            let _id = _item.Type == 1 ? _item.To_Account : _item.ToAccount;
                            return id != _id;
                        });
                    });
                    let flag2 = newMsg.every(item => { //新信息不是自己所发出的
                        return scope.status.loginUser != item.fromAccount;
                    })
                    if (flag1 && flag2) {
                        times++;
                        $timeout(() => {
                            composeNewMsg(newMsg, times, callback);
                        }, 500);
                        return;
                    }
                    //解决列表数据更新不及时的im  but --end
                    newMsgList.forEach(item => {
                        let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                        scope.data.recnetContactList.forEach(item_ => {
                            let id_ = item_.Type == 1 ? item_.To_Account : item_.ToAccount;
                            if (id == id_ && item.MsgTimeStamp != item_.MsgTimeStamp) {
                                item_.MsgTimeStamp = item.MsgTimeStamp;
                                item_.MsgShow = item.MsgShow;
                                item_.MsgSeq = item.MsgSeq;
                                item_.MsgRandom = item.MsgRandom;
                                item_.LastMsg = item.LastMsg;
                                item_.LastC2cMsgFrom_Account = item.LastC2cMsgFrom_Account;
                            }
                            if (id == id_ && item_.Type == 2) { //同步修改资料后的群名称、群头像
                                item_.GroupNick = item.GroupNick;
                                item_.GroupImage = item.GroupImage;
                            }
                        });
                    });
                    newMsgList.forEach(item => {
                        let flag;
                        let id = item.Type == 1 ? item.To_Account : item.ToAccount;
                        flag = scope.data.recnetContactList.every(item_ => {
                            let id_ = item_.Type == 1 ? item_.To_Account : item_.ToAccount;
                            return id != id_;
                        });
                        if (flag) {
                            imService.initRootScopeInfoMap(scope.loginInfo);
                            scope.data.recnetContactList.push(item);
                        }
                    });
                    scope.data.recnetContactList.sort((x, y) => { //重新排序
                        return y.MsgTimeStamp - x.MsgTimeStamp;
                    });
                    //将群消息的发送人，加入消息列表中去，原接口不支持 --start
                    newMsg.forEach(item => {
                        let sess = item.sess
                        let type = sess._impl.type;
                        let id = sess._impl.id;
                        if (type == "C2C") return;
                        scope.data.recnetContactList.forEach(item_ => {
                            if (item_.Type == 1) return;
                            if (item_.ToAccount == id) {
                                item_.fromAccountNick = item.fromAccountNick;
                            }
                        });
                    });
                    callback();
                });
            }
            /**
             * [initRecentContactList description] 初始化最近聊天记录
             * @return {[type]} [description]
             */
            function initRecentContactList(count = scope.status.reqRecentSessCount) {
                let deffer = $q.defer();
                let optioin = {
                    Count: count
                };
                webim.getRecentContactList(optioin, resp => {
                    $timeout(() => {
                        deffer.resolve(angular.isArray(resp.SessionItem) ? resp.SessionItem : []);
                    });
                }, resp => {
                    deffer.reject();
                });
                return deffer.promise;
            }
        }
    };
}]);